import { createBulkMutationHook, createDefaultMutationHook } from "hooks/useMutationHandler";

import { RUN_SET_PRIORITY } from "./gql";

const useSetRunPriority = createDefaultMutationHook(RUN_SET_PRIORITY);
export const useBulkSetRunPriority = createBulkMutationHook(RUN_SET_PRIORITY);

export default useSetRunPriority;
